package com.sddamico.swigmore.util

/**
 * Unsubmitted ballot edits, kept in memory so an owner who leaves the Ballot tab finds their picks
 * when they come back. Lost on reload.
 */
object BallotDrafts {
  /** [slots] as edited from [base], the submitted ballot's slots at the time. */
  data class Draft(val base: List<String?>, val slots: List<String?>)

  private data class Key(val userId: String, val season: Int, val week: Int)

  private val drafts = mutableMapOf<Key, Draft>()

  fun get(userId: String, season: Int, week: Int): Draft? = drafts[Key(userId, season, week)]

  fun put(userId: String, season: Int, week: Int, draft: Draft) {
    drafts[Key(userId, season, week)] = draft
  }

  fun remove(userId: String, season: Int, week: Int) {
    drafts.remove(Key(userId, season, week))
  }
}
